import { useState } from 'react'

import { useParams } from '../../../router/hooks/useParams'
import { Page } from '../../../theme/components/Page'
import { PageSection } from '../../../theme/components/PageSection'
import { StyledCard } from '../../../theme/components/StyledCard'
import { History } from '../components/History'
import { HoofdnetOpdrachtDetails } from '../components/HoofdnetOpdrachtDetails'
import { HoofdnetOpdrachtStatus } from '../components/HoofdnetOpdrachtStatus'
import { Leveringen } from '../components/Leveringen'
import { useHoofdnetOpdracht } from '../hooks/useHoofdnetOpdracht'
import { useLeveringen } from '../hooks/useLeveringen'
import type { HistorySelection } from '../types/HistorySelection'

export const HoofdnetOpdracht = () => {
  /* v8 ignore next - TODO: missing coverage -- @preserve */
  const { id = '' } = useParams()
  const { data: opdracht, isLoading, isError } = useHoofdnetOpdracht({ id })
  const { data: leveringen, isError: isErrorLeveringen } = useLeveringen({ id })

  // The selection stays after closing, so the history shows while it closes
  const [historySelection, setHistorySelection] = useState<
    HistorySelection | undefined
  >()
  const [historyOpen, setHistoryOpen] = useState(false)

  const onOpenHistory = (selection: HistorySelection) => {
    setHistorySelection(selection)
    setHistoryOpen(true)
  }

  if (isLoading) {
    return
  }

  return (
    <Page
      title={[opdracht ? `${opdracht.opdrachtId}` : 'Opdracht', 'Hoofdnet']}
      breadcrumbs={[
        { label: 'Hoofdnet', href: '/home', tooltip: 'CAPO home' },
        {
          label: 'Opdrachten',
          href: '/hoofdnetopdrachten',
          tooltip: 'Hoofdnet opdrachten overzicht',
        },
        {
          label: opdracht ? opdracht.opdrachtId : 'Opdracht',
        },
      ]}
    >
      <PageSection
        id="hoofdnetopdracht"
        heading={
          isError
            ? 'Hoofdnet opdracht niet gevonden'
            : `Hoofdnet opdracht ${id}`
        }
      />

      {opdracht?.opdrachtId && (
        <>
          <StyledCard title="Gegevens">
            <HoofdnetOpdrachtDetails opdracht={opdracht} />
          </StyledCard>
          <StyledCard title="Status">
            <HoofdnetOpdrachtStatus
              opdracht={opdracht}
              onOpenHistory={onOpenHistory}
            />
          </StyledCard>
          <StyledCard title="Leveringen">
            <Leveringen
              leveringen={leveringen}
              isError={isErrorLeveringen}
              onOpenHistory={onOpenHistory}
            />
          </StyledCard>
          {historySelection && (
            <History
              selection={historySelection}
              history={opdracht.history}
              open={historyOpen}
              onClose={() => setHistoryOpen(false)}
            />
          )}
        </>
      )}
    </Page>
  )
}
